module.exports = __webpack_public_path__ + "prod/1.42.2/img/select-bj-2.3d18ac38.jpg";